import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { showSuccess } from '@spike/notifications-action';
import clsx from 'clsx';
import { Button, ControlledTextField2 } from 'components/UI';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';

export interface PayByLinkProps {
    payLink: string;
    amountToPay: string;
    className?: string;
    onClose?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        payByLinkContainer: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%'
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
            width: '100%',
            paddingTop: 36,
            paddingBottom: 18
        },
        footer: {
            display: 'flex',
            width: '100%',
            paddingTop: 18
        },
        payByLinkIconContainer: {
            backgroundColor: '#000',
            borderRadius: '50%',
            width: '90px',
            height: '90px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px'
        },
        payByLinkIcon: {
            fontSize: '36px',
            color: '#fff'
        },
        payByLinkTitle: {
            fontSize: '32px',
            fontWeight: 600,
            marginBottom: '20px'
        },
        payByLinkDescription: {
            fontSize: '18px',
            lineHeight: 1.2,
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '420px',
            textAlign: 'center',
            marginBottom: '30px'
        },
        payByLinkInputContainer: {
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '100%'
        },
        payByLinkInput: {
            'width': '100%',
            '& input': {
                paddingRight: '103px',
                paddingTop: '17px',
                paddingBottom: '17px'
            },
            '& fieldset': {
                borderColor: '#D3D3D3 !important'
            }
        },
        payByLinkCopyButton: {
            'position': 'absolute',
            'right': 10,
            'backgroundColor': '#222',
            'color': '#fff',
            'minHeight': '40px',
            'minWidth': '80px',
            '& span': {
                fontSize: '14px'
            },
            '&:hover': {
                backgroundColor: '#333'
            },
            '& .MuiButton-startIcon': {
                marginRight: 5,
                width: '15px',
                height: '15px'
            },
            '& svg': {
                marginRight: 5,
                width: '15px',
                height: '15px'
            }
        },
        payByLinkDoneButton: {
            width: '100%',
            backgroundColor: '#222',
            color: '#fff',
            height: '55px',
            [theme.breakpoints.up('md')]: {
                height: '55px'
            }
        }
    })
);

export const PayByLink: FunctionComponent<PayByLinkProps> = props => {
    const classes = useStyles();

    const dispatch = useDispatch();

    const copyToClipboard = () => {
        navigator.clipboard.writeText(props.payLink || '');
        dispatch(showSuccess('Link copied!'));
    };

    return (
        <Box className={clsx(classes.payByLinkContainer, props.className)}>
            <Box className={classes.body}>
                <Box className={classes.payByLinkIconContainer}>
                    <FontAwesomeIcon
                        icon={faLink}
                        className={classes.payByLinkIcon}
                    />
                </Box>
                <Typography className={classes.payByLinkTitle}>Payment Link Sent</Typography>
                <Typography className={classes.payByLinkDescription}>
                    Your payment link for <strong>${props.amountToPay}</strong> has been successfully created and sent
                    to the client.
                </Typography>
                <Box className={classes.payByLinkInputContainer}>
                    <ControlledTextField2
                        className={classes.payByLinkInput}
                        name="payment_link"
                        id="payment_link"
                        value={props.payLink || ''}
                        readOnly={true}
                        onChange={() => {}}
                    />
                    <Button
                        size="medium"
                        color="black"
                        label="Copy"
                        startIcon={faCopy}
                        onClick={copyToClipboard}
                        className={classes.payByLinkCopyButton}
                    />
                </Box>
            </Box>
            <Box className={classes.footer}>
                <Button
                    size="large"
                    color="black"
                    label="Done"
                    className={classes.payByLinkDoneButton}
                    onClick={props.onClose}
                />
            </Box>
        </Box>
    );
};

export default PayByLink;
